 
import BaseLayout from "./BaseLayout"
import Prosidebar from "../../components/Layout/Prosidebar"

const ProSidebarLayout = ({ children, islogin }) => {
  return (
    <BaseLayout SidebarComponent={Prosidebar} sidebarProps={{}} islogin={islogin}>
      {children}
    </BaseLayout>
  )
}

export default ProSidebarLayout
